import OnlyHeader from "components/Layout/OnlyHeader";
import AddStoreTimingModal from "components/Modals/AddStoreTimingModal";
import EditStoreTimingModal from "components/Modals/EditStoreTimingsModal";
import StoreTimingsTable from "components/Settings/StoreTimings/StoreTimingsTable";
import { useState } from "react";
import { Container } from "reactstrap";

function StoreTimings() {
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState("");
  const [index, setIndex] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);

  const addToggle = () => setAddModal(!addModal);
  const editToggle = () => setEditModal(!editModal);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <StoreTimingsTable
          addToggle={addToggle}
          editToggle={editToggle}
          deleteToggle={deleteToggle}
          setEditData={setEditData}
          setIndex={setIndex}
        />
      </Container>
      <AddStoreTimingModal addModal={addModal} addToggle={addToggle} />
      <EditStoreTimingModal
        editModal={editModal}
        editToggle={editToggle}
        index={index}
        editData={editData}
      />
    </>
  );
}

export default StoreTimings;
